
const LoadingOrError = ({ isLoading, hasError, error }) => {
  if (isLoading) return <div>Loading...</div>;
  if (hasError) return <div>Error: {error}</div>;
  return null;
};

export default LoadingOrError;